import { createSelector } from '@reduxjs/toolkit';

import type { Scene } from '../../types/scene';
import type { RootState } from '../types';
import type { SceneEditMode, SceneLoadingStatus, SceneState } from './scene.types';

export const NAME = 'scene';
export const SCENE_EDIT_MODE_VIEWING = 'viewing';
export const SCENE_EDIT_MODE_EDITING = 'editing';

export const getStartDeepLinkedScene = (state: RootState): string | null => state[NAME].startDeepLinkedScene;
export const getStartWithProvidedGraph = (state: RootState): SceneState['startWithProvidedGraph'] =>
  state[NAME].startWithProvidedGraph;
export const isStartWithNewSceneActive = (state: RootState): boolean => state[NAME].startWithNewScene;

export const getScenes = createSelector(
  (state: RootState) => state[NAME].scenes,
  (scenes) => {
    const allScenes = Object.values(scenes);
    return allScenes.sort((firstEl, secondEl) => secondEl.createdAt.getTime() - firstEl.createdAt.getTime());
  },
);
export const getCurrentSceneId = (state: RootState) => state[NAME].currentSceneId;
export const getCurrentScene = (state: RootState) =>
  state[NAME].currentSceneId !== undefined ? state[NAME].scenes[state[NAME].currentSceneId] : undefined;
export const getSceneById =
  (state: RootState) =>
  (id: Scene['id']): Scene | undefined =>
    state[NAME].scenes[id];
export const getCurrentNodePositions = (state: RootState): SceneState['currentNodePositions'] =>
  state[NAME].currentNodePositions;
export const getSceneEditMode = (state: RootState): SceneEditMode => state[NAME].editMode;
export const showViewingModeMessage = (state: RootState) => state[NAME].showViewingModeMessage;
export const isCurrentSceneTemporary = (state: RootState): boolean => Boolean(getCurrentScene(state)?.temporaryData);

export const getSceneLoadingStatus = (state: RootState): SceneLoadingStatus => state[NAME].sceneLoadingStatus;
